import { transformWaitMusic } from './transformWaitMusic';
export function transformWaitMusicReadResponse(response) {
    response.data.wait_music.forEach((waitMusic) => {
        transformWaitMusic(waitMusic);
    });
    return response;
}
